import React, { memo, useCallback } from 'react';
import classnames from 'classnames';
import { Icon, Text } from '@Sage/hoi-poi-ui';
var _ref2 = /*#__PURE__*/React.createElement("div", {
  className: "data-grid-field-selector__divider"
});
const ActionsMenu = /*#__PURE__*/memo(_ref => {
  let {
    fieldSelectorProps,
    onToggleMenu
  } = _ref;
  const {
    actions
  } = fieldSelectorProps;
  const onClick = useCallback(actionOnClick => {
    onToggleMenu();
    actionOnClick();
  }, [onToggleMenu]);
  const getActionsMenuItem = useCallback(current => {
    const {
      type,
      icon,
      id,
      label,
      onClick: onClickProp,
      disabled
    } = current;
    const actionClassNames = classnames('data-grid-field-selector__action', {
      [`data-grid-field-selector__action--${id}`]: id,
      [`data-grid-field-selector__action--disabled`]: disabled
    });
    switch (type) {
      case 'divider':
        return _ref2;
      case 'title':
        return /*#__PURE__*/React.createElement("div", {
          className: "data-grid-field-selector__title"
        }, label);
      default:
        return /*#__PURE__*/React.createElement("div", {
          className: actionClassNames,
          onClick: () => onClick(onClickProp)
        }, icon && /*#__PURE__*/React.createElement(Icon, {
          className: "data-grid-field-selector__action__icon",
          name: icon,
          color: (current === null || current === void 0 ? void 0 : current.color) || 'currentColor'
        }), /*#__PURE__*/React.createElement(Text, {
          color: (current === null || current === void 0 ? void 0 : current.color) || '',
          className: "data-grid-field-selector__action__label"
        }, label));
    }
  }, [onClick]);
  if (!actions || (actions === null || actions === void 0 ? void 0 : actions.length) === 0) return null;
  const finalActions = actions.map((current, index) => {
    const Item = () => getActionsMenuItem(current);
    return /*#__PURE__*/React.createElement(Item, {
      key: `selector-action-${index}`
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "data-grid-field-selector__actions"
  }, finalActions);
});
export default ActionsMenu;